import { render, staticRenderFns } from "./CartPromoRateItem.vue?vue&type=template&id=8b052ea2&scoped=true&"
import script from "./CartPromoRateItem.vue?vue&type=script&lang=js&"
export * from "./CartPromoRateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b052ea2",
  null
  
)

export default component.exports